import styled from 'styled-components';
import { Header4 } from 'library/styles/text';
import { ButtonBack } from 'library/styles/button';
import { ActionIconListItem } from 'library/styles/icon';
import { Container as Item } from 'library/components/item/styles';
import Colors from 'library/constants/colors';
import { Row as GridRow } from 'library/components/view-mode/grid/styles';
// import { TransitionConfig } from '../../../../library/constants/styles-config';
import {
  Container as AddButton,
} from 'library/components/add-button/styles';

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: calc(100vh - 62px) !important;
  height: 100%;


  > ${Item} {
    top: 62px !important;
    height: calc(100vh - 62px) !important;
  }

  ${AddButton} {
    z-index: 15;
  }
`;

export const Row = styled(GridRow)``;

export const Meta = styled.div`
  display: flex;
  align-items: center;
  width: calc(100% - 120px);
  
  ${ButtonBack} {
    width: auto;
    margin-right: 20px;
  }
`;

export const Header = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 24px 40px;
  background: linear-gradient(180deg, ${Colors.shade06} 0%, ${Colors.shade07} 100%);
  transition: padding-right 0.4s;
  ${({ isShrunk }) => isShrunk && 'padding-right: 580px;'}
  
  
  ${Header4} {
    margin-bottom: 4px;
  }
`;

export const Actions = styled.div`
  box-sizing: border-box;
  display: flex;
`;

export const ActionIcon = styled(ActionIconListItem)`
`;
